/**
 * `EmptyStateCard` — ported from `Foyer_Dashboard_CURRENT.jsx` line 279.
 * Contextual empty-state body for widgets when there's no real traffic.
 */

import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { useC } from '../../lib/theme.js';

const monoFont = "'JetBrains Mono', monospace";
const sansFont = "'Geist', sans-serif";

export interface EmptyStateCardProps {
  icon?: LucideIcon;
  label: string;
  hint: ReactNode;
}

export function EmptyStateCard({ icon: Icon, label, hint }: EmptyStateCardProps): JSX.Element {
  const C = useC();
  return (
    <div
      className="p-5 flex flex-col items-center justify-center text-center"
      style={{ minHeight: 180, opacity: 0.7 }}
    >
      {Icon ? <Icon size={20} color={C.dim} className="mb-3" /> : null}
      <div
        style={{
          fontFamily: monoFont,
          fontSize: 10,
          color: C.muted,
          letterSpacing: 2,
          marginBottom: 6,
        }}
      >
        {label.toUpperCase()}
      </div>
      <div
        style={{
          fontFamily: sansFont,
          fontSize: 12,
          color: C.dim,
          lineHeight: 1.5,
          maxWidth: 220,
        }}
      >
        {hint}
      </div>
    </div>
  );
}
